import * as microsoftTeams from "@microsoft/teams-js";
import config from "../config";

// Helper to get access token via Teams SSO and backend exchange
const getAccessToken = async () => {

  await microsoftTeams.initialize();
  let ssoToken = "";
  // Get Teams SSO token
  let authError = null;
  await microsoftTeams.authentication.getAuthToken({
    successCallback: (token : string) => {
      ssoToken = token;
      microsoftTeams.appInitialization.notifySuccess();
    },
    failureCallback: (reason : string) => {
      authError = reason;
      microsoftTeams.appInitialization.notifyFailure({
        reason: microsoftTeams.appInitialization.FailedReason.AuthFailed,
        message: reason
      });
    },
    resources: [config.teamsResource]
  });
  if (authError) {
    throw new Error(`Teams SSO failed: ${authError}`);
  }

  // Exchange SSO token for access_token via backend
  const apiBaseUrl = config.apiEndpoint;
  const exchangeResponse = await fetch(`${apiBaseUrl}/api/auth/exchange-obo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-functions-key": config.functionKey
    },
    body: JSON.stringify({ id_token: ssoToken })
  });

  if (!exchangeResponse.ok) {
    const errorText = await exchangeResponse.text();
    throw new Error(`Token exchange failed! status: ${exchangeResponse.status}, message: ${errorText}`);
  }

  const exchangeData = await exchangeResponse.json();
  const accessToken = exchangeData.access_token;
  if (!accessToken) {
    throw new Error("No access_token returned from /api/auth/exchange-obo");
  }
  return accessToken;
};

export const checkAiEligibility = async (meetingId: string): Promise<boolean> => {
  const accessToken = await getAccessToken();
  const apiBaseUrl = config.apiEndpoint;

  const response = await fetch(`${apiBaseUrl}/api/auth/client-ai-eligibility/${meetingId}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      "x-functions-key": config.functionKey
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to check AI eligibility: ${response.statusText}`);
  }

  const data = await response.json();
  return data.every((client: { isAiEnabled: boolean }) => client.isAiEnabled);
};

export default getAccessToken;
